var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgDubaiLogo = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 280,
    height: 64,
    viewBox: "0 0 280 64",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2787:906)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.432 19.0947C231.432 19.9162 230.796 20.7192 229.605 21.4023C228.414 22.0853 226.721 22.6177 224.74 22.9321C222.759 23.2465 220.579 23.3287 218.476 23.1684C216.373 23.0082 214.442 22.6126 212.925 22.0317C211.409 21.4508 210.377 20.7107 209.959 19.905C209.54 19.0993 209.755 18.2642 210.575 17.5052C211.396 16.7462 212.785 16.0975 214.568 15.6411C216.351 15.1847 218.447 14.9411 220.591 14.9411C223.466 14.9411 226.224 15.3787 228.257 16.1577C230.29 16.9366 231.432 17.9931 231.432 19.0947Z",
    fill: "#FFB936"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.432 19.0947C231.432 19.9162 230.796 20.7192 229.605 21.4023C228.414 22.0853 226.721 22.6177 224.74 22.9321C222.759 23.2465 220.579 23.3287 218.476 23.1684C216.373 23.0082 214.442 22.6126 212.925 22.0317C211.409 21.4508 210.377 20.7107 209.959 19.905C209.54 19.0993 209.755 18.2642 210.575 17.5052C211.396 16.7462 212.785 16.0975 214.568 15.6411C216.351 15.1847 218.447 14.9411 220.591 14.9411C223.466 14.9411 226.224 15.3787 228.257 16.1577C230.29 16.9366 231.432 17.9931 231.432 19.0947V19.0947Z",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.91 19.0947C227.91 19.6526 227.478 20.1979 226.669 20.6618C225.86 21.1256 224.71 21.4871 223.365 21.7006C222.02 21.9141 220.54 21.9699 219.112 21.8611C217.684 21.7523 216.372 21.4836 215.342 21.0892C214.313 20.6947 213.612 20.1921 213.328 19.645C213.044 19.0979 213.189 18.5307 213.747 18.0154C214.304 17.5 215.247 17.0595 216.458 16.7495C217.669 16.4396 219.092 16.2742 220.548 16.2742C221.515 16.2737 222.473 16.3463 223.367 16.4878C224.26 16.6294 225.073 16.8371 225.756 17.0992C226.44 17.3612 226.982 17.6723 227.352 18.0147C227.721 18.3572 227.911 18.7242 227.91 19.0947Z",
    fill: "#FFC75E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.553 11.854V13.9404",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.076 13.2721L225.148 14.2535",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.685 13.5425L229.186 15.1421",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.55 15.9884L232.19 16.51",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.158 17.8237L233.793 18.1908",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.475 20.1535L233.803 19.9757",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.952 22.6958L232.222 21.6565",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.939 23.8009L229.234 23.0281",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.083 25.8873L225.197 23.9284",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.553 25.2886L220.613 24.2454",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.177 25.9105L216.013 23.9438",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.366 23.8007L211.969 23.0588",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.243 22.7536L208.942 21.6988",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.65 20.2463L207.323 20.0222",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.925 17.8895L207.29 18.2372",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.597 16.0617L208.856 16.5524",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.291 13.5848L211.83 15.1729",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.096 13.2721L215.842 14.2689",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.513 20.7099C149.196 20.3223 148.546 19.9872 147.669 19.759C146.792 19.5308 145.739 19.4229 144.682 19.4529C143.625 19.4829 142.625 19.649 141.845 19.9242C141.066 20.1994 140.552 20.5675 140.387 20.9688C139.938 20.8585 139.428 20.7898 138.898 20.7682C138.368 20.7465 137.832 20.7726 137.333 20.8442C136.834 20.9159 136.385 21.0311 136.022 21.1809C135.66 21.3306 135.393 21.5106 135.244 21.7067H135.153C134.515 21.7078 133.903 21.8054 133.452 21.9783C133 22.1513 132.745 22.3856 132.743 22.6302H127.217",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.365 15.2079C166.65 14.856 167.239 14.5516 168.034 14.3443C168.829 14.137 169.784 14.039 170.744 14.0663C171.703 14.0937 172.61 14.2447 173.316 14.4948C174.023 14.7449 174.487 15.0793 174.634 15.4436C175.132 15.3198 175.714 15.2541 176.308 15.2542C176.987 15.2513 177.65 15.3335 178.197 15.4884C178.743 15.6432 179.142 15.8622 179.333 16.112H179.414C179.993 16.113 180.548 16.2017 180.958 16.3587C181.368 16.5157 181.599 16.7284 181.602 16.9504H186.644",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4568 12.8972H116.762",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2251 29.6389H72.9854",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7106 29.6389H13.2734",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.477 23.9284H292",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.368 31.5013H253.176",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2014 24.9058H113.757",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.249 24.9058H117.286",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.939 28.6962H214.157",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.637 28.6962H217.684",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2529 61.5732H18.8918V80.1773H51.2529V61.5732Z",
    fill: "#00D4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.143 63.0414H23.9976V80.1772H46.143V63.0414Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.143 63.0414H23.9976V80.1772H46.143V63.0414Z",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2529 61.5732H18.8918V80.1773H51.2529V61.5732Z",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7856 63.8218H25.8308V64.9539H28.7856V63.8218Z",
    fill: "#6D6E71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0609 63.8218H31.1062V64.9539H34.0609V63.8218Z",
    fill: "#6D6E71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3322 63.8218H36.3774V64.9539H39.3322V63.8218Z",
    fill: "#6D6E71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6095 63.8218H41.6548V64.9539H44.6095V63.8218Z",
    fill: "#6D6E71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7856 63.8218H25.8308V64.9539H28.7856V63.8218Z",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0609 63.8218H31.1062V64.9539H34.0609V63.8218Z",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3322 63.8218H36.3774V64.9539H39.3322V63.8218Z",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6095 63.8218H41.6548V64.9539H44.6095V63.8218Z",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.242 12.0549V7.11312L158.319 6.29013L158.652 12.9706L156.242 12.0549Z",
    fill: "#99EEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.242 12.0549V7.11312L158.319 6.29013L158.652 12.9706L156.242 12.0549Z",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.407 12.0548H154.869V15.6597H159.407V12.0548Z",
    fill: "#99EEFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M159.408 12.0548H157.926V15.6597H159.408V12.0548Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.407 12.0548H154.869V15.6597H159.407V12.0548Z",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.402 0V12.055",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.212 12.592H159.408",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.212 13.6663H159.408",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.212 14.7403H159.408",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.514 80.1773V62.7633H144.111V53.9191H146.804V45.1599H148.599V32.6219H151.735V23.9516H153.308V15.6213H159.974V21.8034H161.769V30.4775H163.554V34.5963H164.905V43.1005H167.144V51.9447H169.837V60.1861H174.314V68.8603H178.802V80.1773H138.514Z",
    fill: "#99EEFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M174.312 68.8603V60.1861H169.834V51.9446H167.142V80.1773H178.799V68.8603H174.312Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M154.872 24.3381H151.625V80.1735H154.872V24.3381Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M161.423 24.3381H158.176V35.1335H161.423V24.3381Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M159.911 15.8376H156.664V22.1897H159.911V15.8376Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M164.454 36.8952H161.207V49.0429H164.454V36.8952Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M149.246 51.1912H147.088V80.1734H149.246V51.1912Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M141.76 63.0452H139.178V80.1772H141.76V63.0452Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.907 35.1371H148.601V37.2853H164.907V35.1371Z",
    fill: "#E6E7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.233 35.1371H151.158V37.2853H155.233V35.1371Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.24 37.2817H157.813V35.1334H156.24V37.2817Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.772 22.1935H153.311V23.9515H151.738V24.3379H161.772V22.1935Z",
    fill: "#E6E7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.827 22.1935H154.316V24.3417H156.827V22.1935Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.44 24.3381H158.408V22.1898H157.44V24.3381Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.144 49.0469H146.804V51.1951H167.144V49.0469Z",
    fill: "#E6E7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.082 49.0469H150V51.1951H155.082V49.0469Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.345 51.1912H158.301V49.043H156.345V51.1912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.514 80.1773V62.7633H144.111V53.9191H146.804V45.1599H148.599V32.6219H151.735V23.9516H153.308V15.6213H159.974V21.8034H161.769V30.4775H163.554V34.5963H164.905V43.1005H167.144V51.9447H169.837V60.1861H174.314V68.8603H178.802V80.1773H138.514Z",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.539 16.8886H159.711",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.781 17.9588H159.751",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.539 19.033H159.711",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.539 20.1072H159.711",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.539 21.1812H159.711",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.642 22.2554H161.84",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.642 23.3257H161.84",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.738 24.3997H161.842",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.738 25.4739H161.842",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.738 26.5481H161.842",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.738 27.622H161.842",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.738 28.6962H161.842",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.738 29.7666H161.842",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.738 30.8408H163.557",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.738 31.9147H163.557",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.601 32.989H163.556",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.601 34.0629H163.556",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.601 35.1371H164.907",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.601 37.2817H164.907",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.601 38.3556H164.907",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.601 39.4298H164.907",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.601 40.504H164.907",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.601 41.5782H164.907",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.601 42.6483H164.907",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.601 43.7225H167.146",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.601 44.7966H167.146",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.804 45.8707H167.144",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.804 46.9449H167.144",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.804 48.0192H167.144",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.804 49.0893H167.144",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.804 51.2376H167.144",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.804 52.3116H169.837",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.804 53.3859H169.837",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.113 54.4562H169.838",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.113 55.5302H169.838",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.113 56.6044H169.838",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.113 57.6786H169.838",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.113 58.7527H169.838",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.113 59.8267H169.838",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.113 60.8971H174.316",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.113 61.971H174.316",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.514 63.0452H174.314",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.514 64.1194H174.314",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2611 53.6523H59.1987V57.122H64.2611V53.6523Z",
    fill: "#FFB936"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2611 53.6523H59.1987V57.122H64.2611V53.6523Z",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9045 52.6827L64.2934 47.6868H66.1086V53.6525H60.8546V57.1222H65.3825V74.5401H52.3433V80.1773H48.9045V52.6827Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3797 57.9567H52.1589V73.6397H65.3797V57.9567Z",
    fill: "#FFB936"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3797 65.5413V61.2216L56.8482 57.9567H52.1589V60.4759L65.3797 65.5413Z",
    fill: "#FFD586"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1589 63.7485L65.3797 68.8139V66.654L52.1589 61.5886V63.7485Z",
    fill: "#FFD586"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9045 52.6827L64.2934 47.6868H66.1086V53.6525H60.8546V57.1222H65.3825V74.5401H52.3433V80.1773H48.9045V52.6827Z",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1577 54.3632V56.7897",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4268 54.3632V56.7897",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6938 54.3632V56.7897",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3797 57.9567H52.1589V73.6397H65.3797V57.9567Z",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1074 47.6869V45.3956L64.2922 45.6738V47.6869H66.1074Z",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1055 42.405V45.4689",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1589 59.734H65.662",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1589 61.2836H65.662",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1589 62.8367H65.662",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1071 50.1673H59.885V51.5776H66.1071V50.1673Z",
    fill: "#FFB936"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1071 50.1673H59.885V51.5776H66.1071V50.1673Z",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4583 53.4554H79.5208V49.9857H74.4583V53.4554Z",
    fill: "#FFB936"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4583 53.4554H79.5208V49.9857H74.4583V53.4554Z",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.802 49.012L74.4131 44.0161H72.5979V49.9818H77.8519V53.4515H73.324V74.54H86.3632V80.1772H89.802V49.012Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.3298 73.6358H86.5505V54.2821H73.3298V73.6358Z",
    fill: "#FFB936"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.3289 64.0461L86.5496 69.1076V66.6387L73.3289 61.5732V64.0461Z",
    fill: "#FFD586"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5496 65.437V58.2774L76.1323 54.2861H73.3289V60.3754L86.5496 65.437Z",
    fill: "#FFD586"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.802 49.012L74.4131 44.0161H72.5979V49.9818H77.8519V53.4515H73.324V74.54H86.3632V80.1772H89.802V49.012Z",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.5496 50.6927V53.1191",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2827 50.6927V53.1191",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.0134 50.6927V53.1191",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.3298 73.6358H86.5505V54.2821H73.3298V73.6358Z",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.5979 44.0161V41.7249L74.4131 42.0031V44.0161H72.5979Z",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.5979 38.7344V41.7984",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5473 59.734H73.0442",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5473 61.2836H73.0442",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5473 58.1809H73.0442",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5473 56.6313H73.0442",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5473 62.8367H73.0442",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.6021 47.9108H78.8242V46.5005H72.6021V47.9108Z",
    fill: "#FFB936"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.6021 47.9108H78.8242V46.5005H72.6021V47.9108Z",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.676 80.1772V39.8548C180.676 39.8548 184.236 37.9616 184.014 35.8056C184.013 35.7853 184.022 35.7651 184.041 35.7461C184.06 35.7272 184.089 35.7099 184.125 35.6951C184.162 35.6804 184.205 35.6686 184.254 35.6604C184.302 35.6522 184.355 35.6477 184.408 35.6472H194.411C194.465 35.6471 194.518 35.6513 194.567 35.6593C194.616 35.6674 194.66 35.6792 194.697 35.694C194.734 35.7088 194.762 35.7263 194.781 35.7455C194.799 35.7647 194.807 35.7851 194.805 35.8056C194.593 37.9616 198.143 39.8548 198.143 39.8548V80.1772H180.676Z",
    fill: "#E6E7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.602 38.4795C182.084 38.9618 181.438 39.4227 180.676 39.855V80.1774H184.529V39.855C183.771 39.4217 183.126 38.961 182.602 38.4795Z",
    fill: "#BCBEC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.676 39.8548C180.676 39.8548 184.236 37.9616 184.014 35.8056C184.013 35.7853 184.022 35.7651 184.041 35.7461C184.06 35.7272 184.089 35.7099 184.125 35.6951C184.162 35.6804 184.205 35.6686 184.254 35.6604C184.302 35.6522 184.355 35.6477 184.408 35.6472H194.411C194.465 35.6471 194.518 35.6513 194.567 35.6593C194.616 35.6674 194.66 35.6792 194.697 35.694C194.734 35.7088 194.762 35.7263 194.781 35.7455C194.799 35.7647 194.807 35.7851 194.805 35.8056C194.593 37.9616 198.143 39.8548 198.143 39.8548H180.676Z",
    fill: "#FFB936"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.676 80.1772V39.8548C180.676 39.8548 184.236 37.9616 184.014 35.8056C184.013 35.7853 184.022 35.7651 184.041 35.7461C184.06 35.7272 184.089 35.7099 184.125 35.6951C184.162 35.6804 184.205 35.6686 184.254 35.6604C184.302 35.6522 184.355 35.6477 184.408 35.6472H194.411C194.465 35.6471 194.518 35.6513 194.567 35.6593C194.616 35.6674 194.66 35.6792 194.697 35.694C194.734 35.7088 194.762 35.7263 194.781 35.7455C194.799 35.7647 194.807 35.7851 194.805 35.8056C194.593 37.9616 198.143 39.8548 198.143 39.8548V80.1772H180.676Z",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.41 31.5981V35.6473",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.929 36.9183H191.901",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.929 37.7917H191.901",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.929 38.6648H191.901",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.676 39.9245H198.143",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.676 41.6014H183.167",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.802 41.6014H198.293",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.58 41.6014H192.408",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.676 42.9498H183.167",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.802 42.9498H198.293",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.58 42.9498H192.408",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.676 44.298H183.167",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.802 44.298H198.293",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.58 44.298H192.408",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.676 45.6465H183.167",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.802 45.6465H198.293",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.58 45.6465H192.408",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.676 46.9988H183.167",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.802 46.9988H198.293",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.58 46.9988H192.408",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.676 48.3474H183.167",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.802 48.3474H198.293",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.58 48.3474H192.408",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.676 49.6961H183.167",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.802 49.6961H198.293",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.58 49.6961H192.408",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.676 51.0443H183.167",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.802 51.0443H198.293",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.58 51.0443H192.408",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.676 52.3966H183.167",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.802 52.3966H198.293",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.58 52.3966H192.408",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.676 53.7451H183.167",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.802 53.7451H198.293",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.58 53.7451H192.408",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.676 55.0936H183.167",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.802 55.0936H198.293",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.58 55.0936H192.408",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.676 56.442H183.167",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.802 56.442H198.293",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.58 56.442H192.408",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.676 57.7943H183.167",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.802 57.7943H198.293",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.58 57.7943H192.408",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.676 59.1428H183.167",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.802 59.1428H198.293",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.58 59.1428H192.408",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.676 60.4913H183.167",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.802 60.4913H198.293",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.58 60.4913H192.408",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.676 61.8398H183.167",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.802 61.8398H198.293",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.58 61.8398H192.408",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.676 63.1882H183.167",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.802 63.1882H198.293",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.58 63.1882H192.408",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.177 55.5612H221.722V80.1773H260.89C264.632 68.756 256.181 60.8004 246.177 55.5612Z",
    fill: "#33DDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.174 55.5612H243.663C252.497 60.8236 259.99 68.7907 257.005 80.1773H260.887C264.629 68.756 256.178 60.8004 246.174 55.5612Z",
    fill: "#99EEFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M232.059 55.5612H223.82V80.1734H232.059V55.5612Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.722 47.2502V80.1774H229.951V49.2092C225.1 47.9882 221.722 47.2502 221.722 47.2502Z",
    fill: "#00D4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.722 47.2502V80.1774H223.739V47.7216C222.479 47.4164 221.722 47.2502 221.722 47.2502Z",
    fill: "#006A80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.32 55.5573H254.74",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.658 55.5612L221.722 57.1144",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.176 55.5612L249.112 57.1144",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.949 57.8794H249.836",
    stroke: "white",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.949 56.8285H248.545",
    stroke: "white",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.949 58.9304H251.621",
    stroke: "white",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.949 59.9813H253.174",
    stroke: "white",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.949 61.0322H254.293",
    stroke: "white",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.949 62.0833H255.11",
    stroke: "white",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.949 63.1302H256.653",
    stroke: "white",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.949 64.1813H257.379",
    stroke: "white",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.89 80.1774C268.837 55.9051 221.722 47.2502 221.722 47.2502V80.1774H260.89Z",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.722 47.2502V80.1774H229.951V49.2671C227.368 48.5034 224.615 47.8285 221.722 47.2502V47.2502Z",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.21 80.1772H200.36V43.3168C200.363 42.3592 200.913 41.4135 201.97 40.5458C203.028 39.6781 204.567 38.9096 206.482 38.2939L209.285 37.3898L212.089 38.2939C214.003 38.9096 215.543 39.6781 216.6 40.5458C217.657 41.4135 218.207 42.3592 218.21 43.3168V80.1772Z",
    fill: "#00D4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.255 38.2824L211.183 37.9848L209.247 37.3782L206.443 38.2824C204.529 38.898 202.989 39.6666 201.932 40.5343C200.875 41.4019 200.325 42.3477 200.322 43.3053V80.1657H204.073V43.3053C204.084 42.3459 204.643 41.399 205.711 40.5312C206.779 39.6634 208.33 38.8958 210.255 38.2824Z",
    fill: "#009FBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.069 44.2942H206.714V80.1771H212.069V44.2942Z",
    fill: "#66E5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.21 80.1772H200.36V43.3168C200.363 42.3592 200.913 41.4135 201.97 40.5458C203.028 39.6781 204.567 38.9096 206.482 38.2939L209.285 37.3898L212.089 38.2939C214.003 38.9096 215.543 39.6781 216.6 40.5458C217.657 41.4135 218.207 42.3592 218.21 43.3168V80.1772Z",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.118 44.2944H205.454V41.7791C205.453 41.3666 205.688 40.9591 206.143 40.5853C206.598 40.2115 207.261 39.8804 208.086 39.6154L209.286 39.229L210.486 39.6154C211.311 39.8804 211.974 40.2115 212.429 40.5853C212.884 40.9591 213.119 41.3666 213.118 41.7791V44.2944Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.118 44.2944H205.454V41.7791C205.453 41.3666 205.688 40.9591 206.143 40.5853C206.598 40.2115 207.261 39.8804 208.086 39.6154L209.286 39.229L210.486 39.6154C211.311 39.8804 211.974 40.2115 212.429 40.5853C212.884 40.9591 213.119 41.3666 213.118 41.7791V44.2944Z",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.36 45.9211H205.453",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.36 47.2618H205.453",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.36 48.6027H205.453",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.36 49.947H205.453",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.36 51.2877H205.453",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.36 52.6285H205.453",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.36 53.9731H205.453",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.36 55.3138H205.453",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.36 56.6544H205.453",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.36 57.9954H205.453",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.36 59.3401H205.453",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.36 60.6806H205.453",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.36 62.0214H205.453",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.36 63.3621H205.453",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.219 45.9211H218.301",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.219 47.2618H218.301",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.219 48.6027H218.301",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.219 49.947H218.301",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.219 51.2877H218.301",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.219 52.6285H218.301",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.219 53.9731H218.301",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.219 55.3138H218.301",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.219 56.6544H218.301",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.219 57.9954H218.301",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.219 59.3401H218.301",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.219 60.6806H218.301",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.219 62.0214H218.301",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.219 63.3621H218.301",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.714 44.2942V80.1771",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.072 44.2942V80.1771",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.794 41.238H211.534",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.794 42.2814H211.534",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.794 43.3283H211.534",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.0545 38.8233C93.0545 38.8233 87.7501 60.4605 97.9556 80.1348H113.929L93.0545 38.8233Z",
    fill: "#BCBEC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1536 48.9115L96.298 45.1984C95.4913 53.0767 95.4106 67.0481 102.208 80.1347H104.366C98.5065 68.9143 97.7401 57.0332 98.1536 48.9115Z",
    fill: "#A7A9AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.6277 41.9414L93.0545 38.8233C93.0545 38.8233 87.7501 60.4605 97.9556 80.1348H100.124C92.2679 64.9772 93.5991 48.6296 94.6277 41.9414Z",
    fill: "#A7A9AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.121 52.8024C100.121 60.5802 101.442 70.5757 106.394 80.1347H108.562C104.528 72.384 102.925 64.328 102.441 57.408L100.121 52.8024Z",
    fill: "#A7A9AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.066 62.5932C105.867 68.4771 107.723 74.333 110.622 80.1193H112.78C111.036 76.7501 109.755 73.3229 108.747 69.9537L105.066 62.5932Z",
    fill: "#A7A9AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.0545 38.8233C93.0545 38.8233 87.7501 60.4605 97.9556 80.1348H113.929",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.046 38.8233C111.046 38.8233 114.737 56.4846 113.779 80.1657H111.046C108.474 79.7793 93.0552 38.8233 93.0552 38.8233H111.046Z",
    fill: "#F1F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.817 78.8907C113.864 77.6028 113.894 76.3239 113.908 75.054C108.866 64.6565 99.9912 41.2111 99.0937 38.8233H96.9255C97.9743 41.5936 109.743 72.6584 113.817 78.8907Z",
    fill: "#D1D3D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.527 38.8233H101.339C102.66 42.3007 109.064 59.1275 113.884 70.031C113.884 68.1996 113.84 66.4249 113.753 64.7068C109.406 54.3132 104.647 41.7752 103.527 38.8233Z",
    fill: "#D1D3D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.981 38.8233H105.823C106.922 41.7289 110.088 50.0051 113.456 58.3083C113.285 55.8123 113.073 53.5018 112.851 51.4154C110.623 45.7665 108.767 40.9097 107.981 38.8233Z",
    fill: "#D1D3D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.2133 38.8233H93.0552C93.0552 38.8233 108.474 79.8064 111.046 80.1657H113.204C110.632 79.8064 95.2133 38.8233 95.2133 38.8233Z",
    fill: "#D1D3D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.046 38.8233C111.046 38.8233 114.737 56.4846 113.779 80.1657H111.046C108.474 79.7793 93.0552 38.8233 93.0552 38.8233H111.046Z",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.8782 36.1147V38.8233",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.291 36.1147V38.8233",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.6995 36.1147V38.8233",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.106 36.1147V38.8233",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.518 36.1147V38.8233",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.931 36.1147V38.8233",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.34 36.1147V38.8233",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.4221 36.8525H111.203",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.4221 37.8456H111.203",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.798 32.0231C132.832 31.7022 132.696 31.382 132.399 31.0817C132.101 30.7814 131.649 30.5073 131.068 30.2757C130.488 30.0441 129.791 29.8598 129.02 29.7339C128.248 29.608 127.419 29.5432 126.581 29.5432C125.743 29.5432 124.913 29.608 124.142 29.7339C123.371 29.8598 122.674 30.0441 122.093 30.2757C121.513 30.5073 121.06 30.7814 120.763 31.0817C120.466 31.382 120.33 31.7022 120.364 32.0231H132.798Z",
    fill: "#00D4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.519 33.6224H117.629V42.2541H135.519V33.6224Z",
    fill: "#F1F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.71 33.6224H123.147V42.2541H130.71V33.6224Z",
    fill: "#00D4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.519 33.6224H117.629V42.2541H135.519V33.6224Z",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.797 32.0228H120.353V33.6224H132.797V32.0228Z",
    fill: "#E6E7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.797 32.0228H120.353V33.6224H132.797V32.0228Z",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.364 32.0231C120.33 31.7022 120.466 31.382 120.763 31.0817C121.06 30.7814 121.513 30.5073 122.093 30.2757C122.674 30.0441 123.371 29.8598 124.142 29.7339C124.913 29.608 125.743 29.5432 126.581 29.5432C127.419 29.5432 128.248 29.608 129.02 29.7339C129.791 29.8598 130.488 30.0441 131.068 30.2757C131.649 30.5073 132.101 30.7814 132.399 31.0817C132.696 31.382 132.832 31.7022 132.798 32.0231",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.147 42.2543V33.5801",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.707 42.2543V33.5801",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.293 34.7509H129.567",
    stroke: "white",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.293 35.7205H129.567",
    stroke: "white",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.293 36.6944H129.567",
    stroke: "white",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.293 37.668H129.567",
    stroke: "white",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.293 38.6417H129.567",
    stroke: "white",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.293 39.6114H129.567",
    stroke: "white",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.293 40.5851H129.567",
    stroke: "white",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.203 42.2544H115.945V80.1774H137.203V42.2544Z",
    fill: "#F1F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.71 42.2544H123.147V80.1774H130.71V42.2544Z",
    fill: "#33DDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.203 42.2544H115.945V80.1774H137.203V42.2544Z",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.147 42.2544V80.1349",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.707 42.2544V80.1349",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.293 41.5587H129.567",
    stroke: "white",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.293 43.2472H129.567",
    stroke: "white",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.293 44.1203H129.567",
    stroke: "white",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.293 44.9937H129.567",
    stroke: "white",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.293 45.863H129.567",
    stroke: "white",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.293 46.7361H129.567",
    stroke: "white",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.293 47.6096H129.567",
    stroke: "white",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.293 48.4827H129.567",
    stroke: "white",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.293 49.3558H129.567",
    stroke: "white",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.293 50.2291H129.567",
    stroke: "white",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.293 51.0985H129.567",
    stroke: "white",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.293 51.9716H129.567",
    stroke: "white",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.293 52.845H129.567",
    stroke: "white",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.293 53.7181H129.567",
    stroke: "white",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.293 54.5913H129.567",
    stroke: "white",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.293 55.4608H129.567",
    stroke: "white",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.293 56.3339H129.567",
    stroke: "white",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.293 57.207H129.567",
    stroke: "white",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.293 58.0804H129.567",
    stroke: "white",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.293 58.9536H129.567",
    stroke: "white",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.293 59.8267H129.567",
    stroke: "white",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.293 60.6962H129.567",
    stroke: "white",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.293 61.5694H129.567",
    stroke: "white",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.293 62.4425H129.567",
    stroke: "white",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.293 63.3159H129.567",
    stroke: "white",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.293 64.1891H129.567",
    stroke: "white",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.353 34.6039V35.1565",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.353 35.4463V35.9988",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.353 36.2848V36.8412",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.353 37.1271V37.6796",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.353 37.9694V38.5219",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.353 38.8078V39.3642",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.353 39.6502V40.2027",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.353 40.4926V41.0451",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.353 41.3307V41.8871",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.455 43.0618V43.7959",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.472 43.0618V43.7959",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.455 44.6265V45.3606",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.472 44.6265V45.3606",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.455 46.1876V46.9217",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.472 46.1876V46.9217",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.455 47.7526V48.4867",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.472 47.7526V48.4867",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.455 49.3173V50.0514",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.472 49.3173V50.0514",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.455 50.882V51.6161",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.472 50.882V51.6161",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.455 52.4432V53.1773",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.472 52.4432V53.1773",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.455 54.0078V54.7419",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.472 54.0078V54.7419",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.455 55.5728V56.3069",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.472 55.5728V56.3069",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.455 57.1374V57.8677",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.472 57.1374V57.8677",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.455 58.6985V59.4327",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.472 58.6985V59.4327",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.455 60.2633V60.9974",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.472 60.2633V60.9974",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.455 61.8282V62.5623",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.472 61.8282V62.5623",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.455 63.389V64.1232",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.472 63.389V64.1232",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.077 43.0618V43.7959",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.094 43.0618V43.7959",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.077 44.6265V45.3606",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.094 44.6265V45.3606",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.077 46.1876V46.9217",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.094 46.1876V46.9217",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.077 47.7526V48.4867",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.094 47.7526V48.4867",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.077 49.3173V50.0514",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.094 49.3173V50.0514",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.077 50.882V51.6161",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.094 50.882V51.6161",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.077 52.4432V53.1773",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.094 52.4432V53.1773",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.077 54.0078V54.7419",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.094 54.0078V54.7419",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.077 55.5728V56.3069",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.094 55.5728V56.3069",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.077 57.1374V57.8677",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.094 57.1374V57.8677",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.077 58.6985V59.4327",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.094 58.6985V59.4327",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.077 60.2633V60.9974",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.094 60.2633V60.9974",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.077 61.8282V62.5623",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.094 61.8282V62.5623",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.077 63.389V64.1232",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.094 63.389V64.1232",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.958 34.6039V35.1565",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.958 35.4463V35.9988",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.958 36.2848V36.8412",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.958 37.1271V37.6796",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.958 37.9694V38.5219",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.958 38.8078V39.3642",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.958 39.6502V40.2027",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.958 40.4926V41.0451",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.958 41.3307V41.8871",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.531 32.3167V33.329",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.546 32.3167V33.329",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.573 32.3167V33.329",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.6 32.3167V33.329",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.626 32.3167V33.329",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.573 25.497V29.639",
    stroke: "#414042",
    strokeWidth: 0.421879,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2787:906"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-8 0H280V72C280 76.4183 276.418 80 272 80H-8V0Z",
    fill: "white"
  })))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDubaiLogo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/DubaiLogo.38405f8b.svg";
export { ForwardRef as ReactComponent };